<div class="external-email-container" (click)="hideSelect()">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="form">
      <div class="form-title external-only">{{ title }}<span class="badge" fiTranslation="REQUEST_CREATE_APPOINTMENT_BADGE_EXTERNAL_ENQUIRY"></span></div>

      <div class="item-with-radio">
        <fi-input
          [readOnly]="selectedOption !== 'DEALER_PARTNER'"
          type="SELECT"
          valuePropertyPath="id"
          namePropertyPath="name"
          imagePropertyPath="image"
          [roundImage]="true"
          [enableSearch]="true"
          [selectedOptionsOrValues]="selectedValue"
          [multiLineOptionText]="true"
          [options]="options"
          (onSearch)="this.searchedText = $event; doSearch();"
          (onChange)="onSelect($event)"
          labelKey="REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_SEARCH"
          placeholderKey="REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_SEARCH_PLACEHOLDER"
          >

        </fi-input>

        <div class="circle" (click)="selectedOption = 'DEALER_PARTNER'">
          @if (selectedOption === 'DEALER_PARTNER') {
            <div class="inner-circle"></div>
          }
        </div>
      </div>

      @if (selectedPartner && selectedOption === 'DEALER_PARTNER') {
        <div>
          <div class="main-content">
            @if (selectedPartner) {
              <div class="selected-dealer-partner" [class.white]="selectedPartner">
                <div class="result-item" >
                  <div class="delete-selected-dealer" (click)="clearSelectedDealer()" >
                    <mat-icon>close</mat-icon>
                  </div>
                  <div>
                    <div class="kkz">{{selectedPartner.KKZ}}</div>
                    <div class="container">
                      <div>
                        @if (selectedPartner.Name) {
                          <div class="line"
                          >{{selectedPartner.Name}}</div>
                        }
                        @if (selectedPartner.Address?.Address) {
                          <div class="line"
                          >{{selectedPartner.Address.Address}}</div>
                        }
                        @if (selectedPartner.Address?.City || selectedPartner.Address?.ZipCode) {
                          <div class="line"
                          >{{selectedPartner.Address.ZipCode}} {{ selectedPartner.Address.City }}</div>
                        }
                        @if (selectedPartner.Address?.Country) {
                          <div class="line"
                          >{{selectedPartner.Address.Country}}</div>
                        }
                        @if (selectedPartner.Address?.Phone) {
                          <div class="line phone"
                          >{{selectedPartner.Address.Phone}}</div>
                        }
                        @if (selectedPartner?.Email) {
                          <div class="line email"
                          >{{selectedPartner.Email}}</div>
                        }
                      </div>
                      <div>
                        @if (selectedPartner.ContactManagers[0] && false) {
                          <div class="manager-container ContactManager">
                            <img alt="Contact" src="{{selectedPartner.ContactManagers[0].AvatarURL}}">
                            <div class="manager-info">
                              <div class="line">Zuständiger Kontaktmanager:</div>
                              <!-- *ngIf="selectedPartner.ContactManager?.Organisation" -->
                              @if (selectedPartner?.ContactManagers[0]?.FirstName || selectedPartner?.ContactManagers[0]?.LastName) {
                                <div class="line">
                                  {{selectedPartner?.ContactManagers[0]?.FirstName + ' ' + selectedPartner?.ContactManagers[0]?.LastName}}
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (selectedPartner.AreaManager) {
                          <div class="manager-container AreaManager">
                            <img alt="Contact" src="{{selectedPartner?.AreaManager?.AvatarURL}}">
                            <div class="manager-info">
                              <div class="line" fiTranslation="REQUEST_DETAIL_HEADLINE_EXTERNAL_DEALER_AREA_SALES_MANAGER"></div>
                              <!-- *ngIf="selectedPartner?.AreaManager?.Organisation" -->
                              @if (selectedPartner?.AreaManager?.FirstName || selectedPartner?.AreaManager?.LastName) {
                                <div class="line">
                                  {{selectedPartner?.AreaManager?.FirstName + ' ' + selectedPartner?.AreaManager?.LastName}}
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div class="item-with-radio">
        <fi-input
          type="EMAIL"
          [readOnly]="selectedOption !== 'EMAIL'"
          [hasError]="showMultipleEmailError || selectedOption === 'EMAIL' && noEmailEntered"
          (onChange)="externalEmail = $event"
          labelKey="REQUEST_DETAIL_HEADLINE_EXTERNAL_EMAIL"
          placeholderKey="REQUEST_DETAIL_HEADLINE_EXTERNAL_EMAIL_PLACEHOLDER"
          >

        </fi-input>

        <div class="circle" (click)="selectedOption = 'EMAIL'">
          @if (selectedOption === 'EMAIL') {
            <div class="inner-circle"></div>
          }
        </div>
      </div>

      @if (selectedOption === 'EMAIL') {
        <div>
          <fi-checkbox
            class="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="formIsNotHidden"
            >
            <div class="checkbox-label" fiTranslation="ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_RIGHT"></div>
          </fi-checkbox>
        </div>
      }

      <div>
        @if (showMultipleEmailError) {
          <div class="multiple-email-error" fiTranslation="LEAD_ERRORMSG_ASSIGN_EXTERNAL_EMAIL"></div>
        }
        @if (showEmailError) {
          <div class="multiple-email-error">
            @switch (emailError) {
              @case ('ERR_VPT_EXISTS') {
                <span fiTranslation="CONTACT_ERRORMSG_EXTERNAL_DEALER"></span>
              }
              @case ('ERR_BEN_EXISTS') {
                <span fiTranslation="CONTACT_ERRORMSG_EXTERNAL_CONTACTS_USER"></span>
              }
            }
          </div>
        }
        @if (showMultipleEmailError) {
          <div class="multiple-email-error" fiTranslation="ACTION_LEAD_FORWARD_HEADLINE_EXTERNAL_USER_RIGHT"
          ></div>
        }
      </div>

    </div>
  </div>

  <div class="footer">
    <button (click)="submit()" [disabled]="submitting || showMultipleEmailError || !canSubmit">
      <img [src]="iconUrl" alt="Action icon">
      <span fiTranslation="BUTTON_ACTION_LEAD_FORWARD_EXT"></span>
      <span class="external" fiTranslation="External"></span>
    </button>
  </div>
</div>
